import React, {useEffect, useRef, useState} from "react";
import Dialog from "@mui/material/Dialog";
import messages from "res/messages/farsi";
import DialogContent from "@mui/material/DialogContent";
import ICBackIcon from "res/images/back.png";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import ICShoppingCartIcon from "@material-ui/icons/ChatBubbleOutline";
import TitleAddHeader from "../address/TitleAddHeader";
import {useHistory} from "react-router-dom";
import ThumbsUpDownIcon from "@mui/icons-material/ThumbsUpDown";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import {callApi, callEmptyParamsApi} from "../../../connection/ClientApi";
import Urls from "../../../connection/Urls";
import IconRichTextView from "components/input/IconRichTextView";
import ICComment from "res/images/comment.png";
import attachFile from "res/images/attach_file.png";

import ICError from "res/images/error.png";
import {getButtonHeight, IsM_SM} from "my-styles/media/media";
import StarRating from "components/input/StarRating";
import {ALERT_TYPES} from "components/alertMassage/AlertMessage";


export default function AddComment(props) {

    const [open, setOpen] = useState(false)
    const history = useHistory()
    const [suggestType, setSuggestType] = useState(undefined)
    const [suggestSelectType, setSuggestSelectType] = useState(2)
    const [selectedNamePhotos, setSelectedNamePhotos] = useState([]);
    const [getConfig, setConfig] = useState({});
    const imageSelector = useRef(null);
    const [selectedPhotos, setSelectedPhotos] = useState([]);
    const [starRatingValue, setStarRatingValue] = useState(3);
    const [commentDescription, setCommentDescription] = useState(undefined)

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setStarRatingValue(3);
        setSuggestSelectType(2);
        setSelectedPhotos([]);
        setCommentDescription(undefined)
    };

    function handleSuggestDivClick(item) {
        setSuggestSelectType(item)
    }

    const handleDelete = async (imageName, index) => {
        try {
            const formData = new FormData();
            formData.append('images', imageName);


            const updatedPhotos = [...selectedPhotos];
            const updateSelectedNamePhotos = [...selectedNamePhotos];
            updatedPhotos.splice(index, 1);
            updateSelectedNamePhotos.splice(index, 1);

            // حذف تصویر از سرور
            await deleteImageAsync(formData);


            setSelectedPhotos(updatedPhotos);
            setSelectedNamePhotos(updateSelectedNamePhotos);
        } catch (error) {
            props.onAlert(messages.sendMessageError);
        }
    };
    const requestGetSuggestType = () => {

        callEmptyParamsApi(Urls.getCommentSuggestType, (data) => {
            if (data.result === 'success') {

                setSuggestType(data.list)
            }
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }
    const requestGetConfigFile = () => {

        callEmptyParamsApi(Urls.getCommentConfigFile, (data) => {

            if (data.result === 'success') {
                setConfig(data.config)
            }
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }
    const callApiAsync = (url, data) => {
        return new Promise((resolve, reject) => {
            callApi(
                url,
                data,
                (responseData) => {
                    resolve(responseData);
                },
                () => {
                    reject(new Error('خطا در درخواست API'));
                },
                () => {

                },
                () => {

                }
            );
        });
    };
    const uploadImageToServer = async (image) => {
        try {
            const formData = new FormData();
            formData.append('image', image);
            return await callApiAsync(Urls.uploadImage, formData);
        } catch (error) {
            props.onAlert(messages.sendMessageError);
            return null;
        }
    };
    const handleFileChange = async (e) => {
        const files = e.target.files;
        const newImages = [];
        const newNameImages = [];

        let selectedCountPhotos = selectedPhotos.length;

        let countSelectAndBeforSelect = files.length + selectedCountPhotos;

        if (countSelectAndBeforSelect >= getConfig.imageCount) {
            props.onAlert(messages.maxCountSelectImage);
        }

        let countDefaultFiles = files.length > getConfig.imageCount ? getConfig.imageCount : files.length;

        let sizeDefaultImage = getConfig.imageSize * 1024 * 1024;

        for (let i = 0; i < countDefaultFiles; i++) {
            const file = files[i];
            const fileSizeInBytes = file.size;
            if (sizeDefaultImage <= fileSizeInBytes) {
                props.onAlert('حداکثر سایز فایل انتخابی ' + getConfig.imageSize + ' مگابایت می باشد');
            } else {
                const url = URL.createObjectURL(file);
                const response = await uploadImageToServer(file);
                newImages.push(url);
                newNameImages.push(response.data);
                if (response) {
                    let selectedPhotosList = [...selectedPhotos, ...newImages];
                    let selectedNamePhotosList = [...selectedNamePhotos, ...newNameImages];

                    setSelectedPhotos(selectedPhotosList.slice(0, 5));
                    setSelectedNamePhotos(selectedNamePhotosList.slice(0, 5));
                }
            }
        }
    };
    const deleteImageAsync = (formData) => {
        return new Promise((resolve, reject) => {
            callApi(
                Urls.deleteImage,
                formData,
                (responseData) => {
                    resolve(responseData);
                },
                () => {
                    reject(new Error('خطا در حذف تصویر'));
                },
                () => {
                    props.onLoading(true);
                },
                () => {
                    props.onLoading(false);
                }
            );
        });
    };

    const handleGetRating = (rating) => {
        setStarRatingValue(rating);
    };

    function submitComment() {
        let params = new FormData();
        params.append("product_id", props.product_id);

        if (starRatingValue <= 0) {
            props.onAlert(messages.errorScoreComment);
            return false;
        } else {
            params.append("score", starRatingValue);
        }

        if (suggestSelectType !== undefined) {
            params.append("suggest_type", suggestSelectType);
        }

        if (commentDescription === undefined || commentDescription === '') {
            props.onAlert(messages.errorTextComment);
            return false;
        } else {
            let comment = commentDescription;
            let regex = /^[\u0600-\u06FF\s]+$/;

            if (!regex.test(comment)) {
                props.onAlert(messages.errorCharsetTextComment);
                return false;
            }

            comment = comment.trim();
            if (comment === '') {
                props.onAlert(messages.errorTextComment);
                return false;
            }
            if (comment.length < 10) {
                props.onAlert(messages.errorCountTextComment);
                return false;
            }
            params.append("comment", commentDescription);
        }

        if (selectedNamePhotos.length > 0) {
            params.append(`images`, selectedNamePhotos.join(','));
        }

        callApi(Urls.addProductComment, params, (response) => {

                if (response.result === 'success') {
                    props.onAlert(messages.sendMessageSuccess, ALERT_TYPES.SUCCESS);
                    props.onNavigate(history, `/commentList?v=${props.product_id}&p=1`)
                } else {
                    props.onAlert(messages.sendMessageError)
                }
            }, () => {
                props.onAlert(messages.sendMessageError)
            }, () => {
                props.onLoading(true)
            }, () => {
                props.onLoading(false)
            }
        )

    }

    useEffect(() => {
        requestGetSuggestType()
        requestGetConfigFile()
        setStarRatingValue(3)
    }, []);

    return (
        <div>
            <IconTitleButtonRound
                backgroundcolor={"var(--red_3)"}
                height={"3em"}
                width={"100%"}
                direction="ltr"
                fontSize="mediumTextBold"
                onClick={handleOpen}
                icon={<ICShoppingCartIcon
                    className={'whiteColor'}
                    fontSize={"small"}/>}
                title={messages.submitComment}/>

            <Dialog open={open}>

                <DialogContent>
                    <TitleAddHeader
                        icon={ICBackIcon}
                        title={messages.submitComment}
                        onIconClick={handleClose}/>
                    <div className={"marginLeftRightMedium flex-align-center flex-dir-column"}
                         style={{marginTop: '-1.5rem'}}>

                        <div style={{width: '100%', display: 'flex', ...(IsM_SM() ? {flexDirection: 'column'} : {})}}>
                            <div style={{width: '100%', display: 'flex', alignItems: 'center', gap: '0.6rem'}}>
                                <p className={"mediumTextBold"}> {messages.setScore}</p>
                                {<StarRating onChange={handleGetRating} key={Math.random() * 2}
                                             starRatingValue={starRatingValue}/>}

                            </div>
                            {suggestType && suggestType.length > 0 ?
                                <div className={"flex-justify-center"} style={{gap: '1rem', width: '100%'}}>
                                    {suggestType.map((suggest, index) => {
                                        return <div
                                            className={suggestSelectType && suggestSelectType === suggest.type ? 'box-suggest-active' : 'box-suggest'}
                                            style={{cursor: 'pointer'}}
                                            onClick={() => handleSuggestDivClick(suggest.type)}>
                                            {suggest.type === 1 &&
                                                <ThumbUpAltIcon key={index} style={{fill: 'var(--green_3)'}}/>}
                                            {suggest.type === 2 &&
                                                <ThumbsUpDownIcon key={index} style={{fill: 'var(--green_4)'}}/>}
                                            {suggest.type === 3 &&
                                                <ThumbDownAltIcon key={index} style={{fill: 'var(--yellow_1)'}}/>}
                                            <div>
                                                <span className={"mediumText"}>{suggest.title}</span>
                                            </div>
                                        </div>
                                    })}
                                </div>
                                : <div></div>
                            }
                        </div>

                        <div style={{width: '100%'}}>
                            {IsM_SM() ? " " : <p className={"mediumText"}>{messages.enterComment}</p>}

                            <IconRichTextView
                                className="boxInputMassageTicket boxInputMassageTicket borderRadiusOne"
                                style={{borderRadius: '1em', marginTop: '0.7rem'}}
                                placeholder={messages.textComment}
                                height={IsM_SM() ? "4rem" : "10em"}
                                icon={<img alt={"صرفه مارکت"} src={ICComment}
                                           className="marginSmall xSmallIcon"/>}
                                onChange={(event) => {
                                    setCommentDescription(event.target.value)
                                }}/>
                        </div>

                        <div className="cardImageSelect1 boxInputMassageTicket"
                             style={{marginTop: '0.1rem', width: "100%", position: 'relative'}}>
                                   <span style={{display: 'flex', alignItems: 'center', fontSize: '0.9rem'}}
                                         onClick={() => {
                                             imageSelector.current.click()
                                         }}>
                                      <img alt={"صرفه مارکت"} src={attachFile}
                                           className="marginSmall xSmallIcon"/>
                                       {messages.addIamge}
                                            </span>

                            <div className="threeFromFive multiCardShowImage bodyCardImageSelect">
                                {selectedPhotos.map((photo, index) => (
                                    <div style={{position: 'relative', width: '5rem', height: '3rem', margin: '1rem 0'}}
                                         key={index}>
                                        <img className="leftSideBg clearImageIcon" src={ICError} alt={"صرفه مارکت"}
                                             onClick={() => handleDelete(selectedNamePhotos[index], index)}/>
                                        <img className="leftSideBg itemImage" src={photo} alt={"صرفه مارکت"}/>
                                    </div>
                                ))}

                            </div>
                            {getConfig &&
                                <span className="textLight2"
                                      style={{left: '0 !important'}}>{selectedPhotos.length}/{getConfig.image_count} | حداکثر حجم هر تصویر {getConfig.image_size} مگابایت</span>}

                        </div>

                        <div style={{marginTop: '2rem', marginBottom: '1.5rem', width: '100%'}}>
                            <IconTitleButtonRound
                                height={getButtonHeight()}
                                fontSize="mediumTextBold"
                                backgroundcolor="var(--blue_3)"
                                onClick={() => {
                                    submitComment()
                                }}
                                title={messages.submitComment}/>

                        </div>
                    </div>

                </DialogContent>

            </Dialog>
            <input
                id='file'
                type='file'
                multiple
                onChange={handleFileChange}
                ref={imageSelector}
                style={{display: 'none'}}/>
        </div>

    );

}